import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from 'app/config.service';
import moment from 'moment-timezone';

@Pipe({
    name: 'timezone',
    standalone: false
})
export class TimezonePipe implements PipeTransform {
	constructor(private configService: ConfigService) {}

	transform(value: any, timezone: any): any {
		if (value && timezone) {
			return moment
				.tz(value, timezone)
				.format(this.configService.momentTimeFormat);
		}
	}
}
